module.exports = __webpack_public_path__ + "img/roll_s_a.993d106c.png";